module.exports = __webpack_public_path__ + "static/img/email.c690b213.png";